import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./WmsGridCheckBoxSelection.scss";
import _ from "lodash";

interface GridProps {
    id?: string; // this should write the id to the radio
    onRequestEnd?: any; // this should control the onchange event and anything we need to determine before we send it up
    onSelectRow?: any; // this should control the selection event
    transport?: any; // grid read , update and remove transport object
    changeColumnsDynamic?: boolean; // grid read , update and remove transport object
    staticGridData?: any; // grid read , update and remove transport object
    schema?: any; // grid columns type structure
    columns?: any; // grid columns
    gridEditable?: any; // object for editable grid
    onEdit?: any; // called function after edit column
    bindSelectRow?: boolean; // bind row click event
    bindHeaderSelect?: boolean; // bind header checkbox click event
    keyId?: string; // row click id
    callMethodAfterInitialize?: any; // this method call on grid initiation complete, we not use databound inbuilt kendo event because it's call read call continues on using setOption
    changeRemoteGridColumn?: boolean; // on set true it allow to change remote grid column update.
    combineSelectedRow?: boolean;
    columnMenu?: any;
    filterable?: boolean;
}

const CHECKBOX_SELECTOR = "input.k-select-checkbox.k-checkbox, input.k-checkbox";
const SELECTED_CLASS = "k-selected";
const STATE_SELECTED_CLASS = "k-state-selected";

const syncCheckboxUi = ($checkbox: JQuery, checked: boolean) => {
    if (!$checkbox || !$checkbox.length) {
        return;
    }
    const el = $checkbox.get(0) as HTMLInputElement;
    el.checked = checked;
    $checkbox.attr("aria-checked", checked ? "true" : "false");
    $checkbox.toggleClass("k-checked", checked);
};

const WmsGridCheckBoxSelection: React.FC<GridProps> = (incomingProps: GridProps): any => {
    const {
        onSelectRow = () => {},
        bindSelectRow = false,
        bindHeaderSelect = false,
        keyId = "Id",
        gridEditable = false,
        onEdit = () => {},
        callMethodAfterInitialize = () => {},
        changeRemoteGridColumn = false,
        combineSelectedRow = false,
        columnMenu = {
            sortable: false,
        },
        filterable = true,
    } = incomingProps;
    const props = {
        ...incomingProps,
        onSelectRow,
        bindSelectRow,
        bindHeaderSelect,
        keyId,
        gridEditable,
        onEdit,
        callMethodAfterInitialize,
        changeRemoteGridColumn,
        combineSelectedRow,
        columnMenu,
        filterable,
    };

    var rowCheckedIds = {};

    const emitSelectionFromGrid = (grid) => {
        const nextCheckedIds = {};
        const rows = grid.select();
        if (rows && rows.length) {
            rows.each(function (_index, row) {
                const selectedItem = grid.dataItem(row);
                if (selectedItem && selectedItem[props.keyId] != null) {
                    nextCheckedIds[`${selectedItem[props.keyId]}`] = true;
                }
            });
        }
        if (props.combineSelectedRow) {
            rowCheckedIds = nextCheckedIds;
        }
        props.onSelectRow(nextCheckedIds);
    };

    useEffect(() => {
        var kendoGrid = $(`#${props.id}`).data("kendoGrid");
        if (!kendoGrid) {
            let dataSourceObj = null;
            if (props.transport) {
                dataSourceObj = new kendo.data.DataSource({
                    transport: props.transport,
                    pageSize: 100,
                    serverPaging: true,
                    serverSorting: true,
                    schema: props.schema,
                    type: "aspnetmvc-ajax",
                    requestEnd: (e) => {
                        props.onRequestEnd(e);
                    },
                });
            } else {
                dataSourceObj = {
                    data: props.staticGridData,
                    schema: props.schema,
                };
            }
            let grid = $(`#${props.id}`)
                .kendoGrid({
                    dataSource: dataSourceObj,
                    // height: 430,
                    columns: props.columns,
                    columnMenu: props.columnMenu,
                    sortable: true,
                    filterable: props.filterable,
                    editable: props.gridEditable,
                    // Persist checkbox UI with Kendo's built-in selectable column behavior.
                    persistSelection: true,
                    edit: (e) => {
                        props.onEdit(e);
                    },
                    change: () => {
                        // Prefer Kendo selection state so header + row checkboxes stay in sync.
                        emitSelectionFromGrid($(`#${props.id}`).data("kendoGrid"));
                    },
                })
                .data("kendoGrid");

            // Only use custom row-click selection when explicitly requested.
            // Do NOT bind custom checkbox clicks — they fight Kendo's _checkboxClick
            // and clear the visible checked state while selection data still updates.
            if (grid && grid.table && props.bindSelectRow) {
                grid.table.off("click", "tr", selectedTableRow);
                grid.table.on("click", "tr", selectedTableRow);
            }
            if (props.callMethodAfterInitialize) {
                props.callMethodAfterInitialize();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    });
    useEffect(() => {
        if (props.changeColumnsDynamic) {
            var column = {
                columns: props.columns,
            };
            var grid = $(`#${props.id}`).data("kendoGrid");
            grid.setOptions(column);
        }
    }, [props.changeColumnsDynamic, props.columns, props.id]);
    useEffect(() => {
        if (props.changeRemoteGridColumn) {
            var column = {
                columns: props.columns,
            };
            var grid = $(`#${props.id}`).data("kendoGrid");

            let newDS = new kendo.data.DataSource({
                transport: props.transport,
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                schema: props.schema,
                type: "aspnetmvc-ajax",
                requestEnd: (e) => {
                    props.onRequestEnd(e);
                },
            });
            grid.setOptions(column);
            grid.setDataSource(newDS);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.changeRemoteGridColumn]);

    useEffect(() => {
        var grid = $(`#${props.id}`).data("kendoGrid");
        if (typeof grid != "undefined") {
            grid.dataSource.data(props.staticGridData);
        }
    }, [props.id, props.staticGridData]);

    function selectedTableRow(e) {
        if (
            $(e.target).closest(CHECKBOX_SELECTOR).length ||
            $(e.target).hasClass("k-checkbox-label") ||
            $(e.target).hasClass("k-checkbox") ||
            $(e.target).hasClass("k-select-checkbox")
        ) {
            return;
        }
        let row = $(e.target).closest("tr");
        let grid = $($(`#${props.id}`)).data("kendoGrid");
        let dataItem = grid.dataItem(row);
        if (!dataItem) {
            return;
        }

        const isSelected = row.hasClass(SELECTED_CLASS) || row.hasClass(STATE_SELECTED_CLASS);
        if (isSelected) {
            grid._deselectCheckRows
                ? grid._deselectCheckRows(row)
                : row.removeClass(`${SELECTED_CLASS} ${STATE_SELECTED_CLASS}`);
            syncCheckboxUi(row.find(CHECKBOX_SELECTOR), false);
            rowCheckedIds[dataItem[props.keyId]] = false;
        } else {
            grid.select(row);
            syncCheckboxUi(row.find(CHECKBOX_SELECTOR), true);
            rowCheckedIds[dataItem[props.keyId]] = true;
        }

        props.onSelectRow(rowCheckedIds);
    }

    return (
        <div className="wms-grid-check-box-selection-component">
            <div id={props.id}></div>
        </div>
    );
};

WmsGridCheckBoxSelection.propTypes = {
    id: PropTypes.string, // this should write the id to the radio
    onRequestEnd: PropTypes.func, // this should control the onchange event and anything we need to determine before we send it up
    onSelectRow: PropTypes.func.isRequired, // this should control the onchange event and anything we need to determine before we send it up
    transport: PropTypes.object, // grid read , update and remove transport object
    changeColumnsDynamic: PropTypes.bool, // grid read , update and remove transport object
    staticGridData: PropTypes.array, // grid records
    schema: PropTypes.object, // grid column type structure
    columns: PropTypes.array, // grid column type
    bindSelectRow: PropTypes.bool, // bind row click event
    bindHeaderSelect: PropTypes.bool, // bind row check box click event
    keyId: PropTypes.string, // grid column type
    callMethodAfterInitialize: PropTypes.func,
    changeRemoteGridColumn: PropTypes.bool,
    combineSelectedRow: PropTypes.bool,
    columnMenu: PropTypes.object,
    filterable: PropTypes.bool,
};

const areEqual: any = (prevProps: any, nextProps: any): any => {
    return _.isEqual(
        _.omit(nextProps, ["onRequestEnd", "onSelectRow", "callMethodAfterInitialize"]),
        _.omit(prevProps, ["onRequestEnd", "onSelectRow", "callMethodAfterInitialize"])
    );
};
export default React.memo(WmsGridCheckBoxSelection, areEqual);
